<template>
	<div>
		<v-row>
			<v-col cols="2" md="1" dense class="d-flex align-center justify-center pa-0">
				<v-badge color="primary" :inline="true" :content="index + 1"> </v-badge>
			</v-col>
			<v-col cols="10" md="4" dense class="pt-1 d-flex align-center">
				<!-- <v-subheader class="ml-md-2 pl-0 subtitle-1">Latime gol</v-subheader> -->
				<v-text-field ref="gateWidth" class="ml-md-2 mt-md-8" pattern="\d*" validate suffix="mm"
					:label="language.configuration.labels.field_label" outlined dense
					:rules="[rules.minLengthPA, rules.maxLengthPA]" type="number" min="1600" v-model="item.latime_gol"
					@focusin="$emit('changeActivePA', true, item.tip, false)"
					@focusout="$emit('changeActivePA', false, item.tip, false)">
				</v-text-field>
			</v-col>
			<v-col cols="12" md="7" class="pl-4 pt-0 d-flex align-center">
				<v-radio-group class="mt-0 pt-0" v-model="item.tip" row hide-details>
					<v-radio class="mt-3" :label="language.configuration.labels.swing" value="batanta"></v-radio>
					<v-radio class="mt-3" :label="language.configuration.labels.sliding" value="culisanta"></v-radio>
					<v-radio class="mt-3" :label="language.configuration.labels.autocarrying"
						value="autoportanta"></v-radio>
				</v-radio-group>
			</v-col>
		</v-row>
		<v-row v-if="model == 'horizontal'">
			<v-col cols="12" md="7">
				<v-subheader class="subtitle-1 pl-1">
					{{ language.configuration.labels.label_obj11 }}
				</v-subheader>
			</v-col>
			<v-col cols="12" md="5" class="ma-0 px-0">
				<v-radio-group class="mt-0 mt-md-2 pl-4 pl-md-2" v-model="item.pp_included" row hide-details>
					<v-radio :label="language.configuration.labels.yes" :value="true"></v-radio>
					<v-radio :label="language.configuration.labels.no" :value="false"></v-radio>
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="5">
				<v-text-field v-if="item.pp_included" class="ml-md-2" pattern="\d*" validate suffix="mm" type="number"
					min="700" max="1200" :rules="[rules.minLengthPPIncluded]"
					:label="language.configuration.labels.field_label_pp" outlined dense v-model="item.latime_pp"
					@focusin="$emit('changeActivePA', true, item.tip, true)"
					@focusout="$emit('changeActivePA', false, item.tip, true)">
				</v-text-field>
			</v-col>
		</v-row>
		<!-- <v-row>
							<v-col cols="7">
								<div v-if="!item.automation">
									<v-btn
										v-if="!item.automation"
										text
										dense
										color="primary"
										class="caption font-weight-bold"
										@click="addAutomation(index)"
									>
										<v-icon left dark>mdi-plus</v-icon>
										Automatizare
									</v-btn>
									<v-tooltip right fixed content-class="white" z-index="2">
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="primary" dark v-bind="attrs" v-on="on">
												mdi-information
											</v-icon>
										</template>
<v-card elevation="2">
	<v-img lazy-src="https://picsum.photos/id/11/10/6" max-height="150" max-width="250"
		src="https://picsum.photos/id/11/500/300"></v-img>
</v-card>
</v-tooltip>
</div>
<div v-else class="ml-3 mb-3">
	<span class="body-2 font-weight-bold primary--text">- cu automatizare pentru poarta {{ item.tip }}</span>
	<v-icon class="ml-1" size="14" @click="removeAutomation(index)">mdi-close</v-icon>
</div>
</v-col>
</v-row> -->
		<v-divider v-if="index < nr_porti - 1" class="mb-4" role="presentation"></v-divider>
	</div>
</template>

<script>
export default {
	name: "PoartaA",
	props: {
		item: Object,
		index: Number,
		model: String,
		nr_porti: Number,
		language: Object,
	},
	data: function () {
		return {
			rules: {
				minLengthPPIncluded: (value) =>
					(value >= 700 && value <= 1200) ||
					`${this.language.configuration.labels.minimum} 700mm  ${this.language.configuration.labels.maximum} 1200mm`,
				minLengthPA: (value) => value >= 1600 || `${this.language.configuration.labels.minimum} 1600mm`,
				maxLengthPA: (value) => this.isMaxLengthRestrict(value) || `${this.language.configuration.labels.maximum} ${this.item.tip == 'batanta' ? '4800' : '4300'}mm`,
			},
		};
	},
	computed: {},
	watch: {
		"item.pp_included"(NewValue, OldValue) {
			if (NewValue != OldValue && this.nr_porti > 1) {
				this.$emit("changedStatusPPA", { value: NewValue, index: this.index });
			}
		},
		"item.tip"(NewValue, OldValue) {
			if (NewValue != OldValue && this.nr_porti > 1) {
				this.$emit("changedTipPA", { value: NewValue, index: this.index });
			}
			this.$refs.gateWidth.validate()
		},
	},
	methods: {
		isMaxLengthRestrict(length) {
			if (this.item.tip == 'batanta') {
				if (length <= 4800) { return true } else return false
			} else if (this.item.tip == 'autoportanta') {
				if (length <= 4300) { return true } else return false
			} else return true
		}
	}
};
</script>

<style scoped></style>
